<template>
    <div>
        <!-- 导航栏 -->
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" style="flex: 1;background-color: rgb(247, 248, 250);overflow: scroll">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有了"
                    @load="onLoad"
            >
                <div
                        v-for="(item,index) in list"
                        :key="index"
                        style="background: #fff;display: flex;padding: 5px 10px"
                        @click="onItemClick(item)"
                >
                    <img :src="item.userInfo?item.userInfo.headImgUrl:''" width="50" height="50" style="margin: 5px;border-radius: 5px;">
                    <div style="flex: 1;display:flex;flex-direction: column;justify-content: center;overflow: hidden;padding:10px 5px;border-bottom:1px solid #ebedf0">
                        <div style="display:flex;flex-direction: row;justify-content: space-between;overflow: hidden">
                            <span style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">{{item.applyName}}</span>

                            <span style="white-space: nowrap;font-size: 14px;color: #646566;">{{getTimeStr(item.createDate)}}</span>
                        </div>
                        <div style="display:flex;flex-direction: row;justify-content: space-between;overflow: hidden">
                            <div style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;font-size: 14px;color: #646566;">
                                <span style="color: black">{{item.theCase?item.theCase:'暂无标题'}}</span>
                            </div>
                            <van-tag :type="getStateTagType(item.applySite)" style="white-space: nowrap;margin-left: 10px;">{{assistanceStatus[item.applySite]}}</van-tag>
                        </div>
                    </div>
                </div>
            </van-list>

        </van-pull-refresh>

    </div>
</template>

<script>

  import {Toast} from 'vant';
  import axios from '../../common/axios';
  import {responseCodes,assistanceStatus,userTypes} from '../../common/const'
  export default {
    name: "AssistanceList",
    props: {
      userType: {
        required:true,
        validator: function (value) {
          if (!((typeof value)==="number")) {
            return  false
          }
          // 这个值必须匹配下列字符串中的一个
          return userTypes[value]
        }
      },
      openId:{
        type:String,
        required:false
      }
    },
    data() {
      return {
        list: [],
        loading: false,
        finished: false,
        refreshing: false,
        page:1,
        size:50,
        message:'',
        userTypes,
        assistanceStatus
      };
    },
    computed:{

    },
    mounted(){
      console.info("userType")
      console.info(this.userType)
    },

    watch:{
      openId:{
        immediate:true,
        handler:function(newVal,oldVal){
          this.onRefresh();
        }
      }
    },
    methods: {
      async onLoad() {
        this.loading = false
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
          this.page=1
        }

        if (this.finished){
          return ;
        }
        this.loading = true;
        let body = {};

        if (this.userType === userTypes.lawyer){
          if (this.openId) {
            body.adminId = this.openId;
          }
        } else if(this.userType === userTypes.customer){
          body.openId =this.openId;
        }

        try {
          let response = await axios.post(`/fyserve/apply/find?page=${this.page}&size=${this.size}`,body)
          let data = response.data;
          if (data.code === responseCodes.success) {
            let dataList = data.data.map((item) => {item.isExpanded = false;return item; })
            this.list.push(...dataList)
            this.page = this.page+1
            if (dataList.length<this.size) {
              this.finished = true;
            }
          }else{
            Toast.fail(data.message);
            this.finished = true
            this.loading = false;
          }
        }catch (e) {
          console.error(e)
          Toast.fail("加载数据失败")
          this.finished = true
          this.loading = false;
        }
        this.loading = false;
      },
      onRefresh() {
        this.refreshing = true;
        this.finished = false;
        this.loading = true;
        this.onLoad();
      },
      getStateTagType(state){
        if (state ===assistanceStatus.agree){
          return "success"
        } else if (state ===assistanceStatus.auditing){
          return "primary"
        } else if( state === assistanceStatus.reject){
          return "danger"
        } else {
          return undefined
        }
      },

      onClickLeft() {
        this.$router.back();
      },
      getTimeStr(createDateStr){
        return createDateStr.split(" ")[0]
      },
      onItemClick(item){
        this.$router.push({
          name:'assistance',
          params:{
            item,
            userType:this.userType
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>